module.exports = __webpack_public_path__ + "img/asmtnotdoneicon.920b887e.svg";